export function normalizeLogoPath(input) {
  const raw = String(input || '').trim()
  if (!raw) return ''
  if (raw.startsWith('/static/logos/')) return raw
  if (raw.startsWith('/usr/src/app/uploads/logos/')) {
    const parts = raw.split('/')
    const file = parts[parts.length - 1] || ''
    return file ? `/static/logos/${file}` : ''
  }
  return raw
}

